import React from 'react'
import PaginationSizeChooser from 'components/PaginationSizeChooser'

const pageEditableSections = ['main', 'allDetail']
const ItemPerPageSelector = ({ isSuperuser, itemPerPage, labelMap, t, onPaginationSizeChanged }) => {

    return (
        <>
        {Object.keys(itemPerPage).map((config) => {
            return (
                <>
                <span className={`model-info-ipp-parent ${config}`}>
                    {labelMap[config] || t(config)}
                </span>
                {t('HAS_IPP')}
                {isSuperuser && pageEditableSections.includes(config) ? <PaginationSizeChooser
                    className='pagination-size-chooser'
                    initialValue={itemPerPage[config]}
                    onChange={(newVal) => onPaginationSizeChanged(config, newVal)}
                    size='sm'
                /> :
                    (<span className='model-info-ipp-field'>
                    {itemPerPage[config]}
                    </span >)
                }

                <div class="break"></div>
                </>
            )
            })}
        </>
        )
    

}

export default ItemPerPageSelector
